import { IDocument, IFolderData, IItem, ILoadData, ISkleraItem } from './interface';
import { isAfter, isBefore, format, parseISO } from 'date-fns';

import { skleraSDK } from '@sklera/sdk';

export const loadData = async (folderId: string): Promise<ILoadData> => {
    const mainFolder: IFolderData = await skleraSDK.getFolderData(folderId);

    const allFolders: Map<string, IFolderData> = new Map();
    const icons: Map<string, IItem> = new Map();
    let allDocuments: IDocument[] = [];

    prepareFolder(mainFolder, allFolders, icons, allDocuments);

    allDocuments = allDocuments.sort(sortForNewest);
    await Promise.all(
        Array.from(icons.values()).map(async (icon) => {
            const data = await skleraSDK.getItemData(icon._id);
            icon.url = data.url;
        })
    );

    return { mainFolder, allFolders, icons, allDocuments };
};

export function prepDate(d: Date | string | undefined | null): Date {
    if (d) {
        if (typeof d === 'string') {
            return parseISO(d);
        }
        return d;
    }
    return new Date();
}

function prepareFolder(
    folder: IFolderData,
    allFolders: Map<string, IFolderData>,
    icons: Map<string, any>,
    allDocuments: IDocument[],
    categoryId?: string,
    subCategoryId?: string
) {
    folder.documents = [];
    folder.items?.forEach((item) => {
        if (item.type === 'image' && item.name === '__icon') {
            folder.iconId = item._id;
            icons.set(item._id, item);
        }
        if (item.type === 'document' && filterDate(item)) {
            folder.documents.push(item);
        }
    });
    folder.documents = folder.documents.sort(sortForNewest);
    folder.documents.forEach((d) => {
        allDocuments.push({ ...d, categoryId, subCategoryId });
    });
    allFolders.set(folder._id, folder);
    let countDocuments = folder.documents.length;
    folder.children?.forEach((f) => {
        prepareFolder(
            f,
            allFolders,
            icons,
            allDocuments,
            categoryId ? categoryId : f._id,
            subCategoryId ? subCategoryId : categoryId && f._id
        );
        countDocuments += f.countDocuments || 0;
    });
    folder.countDocuments = countDocuments;
}

export const filterDate = (item: IItem): boolean => {
    //filter out not valid items by validTo/validFrom dates

    const today = new Date();

    if (item.validFrom && isBefore(today, prepDate(item.validFrom))) {
        return false;
    }

    return !(item.validTo && isAfter(today, prepDate(item.validTo)));

    /*
    if (!item.validFrom && !item.validTo) {
        return true;
    } else if (item.validFrom && item.validTo) {
        return isAfter(today, item.validFrom) && isBefore(today, item.validTo);
    } else if (item.validTo) {
        return isBefore(today, item.validTo);
    } else if (item.validFrom) {
        return isAfter(today, item.validFrom);
    }
    return true; */
};

export const sortForNewest = (a: IItem, b: IItem): number => {
    //sort items by validFrom date
    return (prepDate(b.validFrom)?.valueOf() || 0) - (prepDate(a.validFrom)?.valueOf() || 0);
    /*if (!a.validFrom || !b.validFrom) return 0;
    if (isAfter(a.validFrom, b.validFrom)) return -1;
    if (isBefore(a.validFrom, b.validFrom)) return 1;
    return 0;*/
};

export const sortForOldest = (a: IItem, b: IItem): number => {
    //sort items by validFrom date
    return (prepDate(a.validFrom)?.valueOf() || 0) - (prepDate(b.validFrom)?.valueOf() || 0);
    /*if (!a.validFrom || !b.validFrom) return 0;
    if (isAfter(a.validFrom, b.validFrom)) return -1;
    if (isBefore(a.validFrom, b.validFrom)) return 1;
    return 0;*/
};
export const sortForAlphabetic = (a: IItem, b: IItem): number => {
    //sort items by validFrom date
    return a.name.localeCompare(b.name);
    /*if (!a.validFrom || !b.validFrom) return 0;
    if (isAfter(a.validFrom, b.validFrom)) return -1;
    if (isBefore(a.validFrom, b.validFrom)) return 1;
    return 0;*/
};

export const sortCategory = (a: IFolderData, b: IFolderData): number => {
    return (a.metaData?.mnbOrder || 0) - (b.metaData?.mnbOrder || 0);
};

export const userInput = () => skleraSDK.triggerSessionReset();

export async function downloadFile(downloadItem: ISkleraItem) {
    const downloadUrlObj = new URL(downloadItem.cdnUrl);
    downloadUrlObj.protocol = window.location.protocol;

    fetch(downloadUrlObj.href)
        .then((res) => res.blob())
        .then((res) => {
            const aElement = document.createElement('a');

            let filename = downloadItem.itemDoc.name;
            let extension = downloadItem.itemDoc.extension.replace(/^\./, '');

            const fileParts = filename.split('.');

            if (!(fileParts.length > 1 && fileParts[fileParts.length - 1] === extension)) {
                filename += '.' + extension;
            }

            aElement.setAttribute('download', filename);
            const href = URL.createObjectURL(res);
            aElement.href = href;
            aElement.setAttribute('target', '_blank');
            aElement.click();
            URL.revokeObjectURL(href);
        });
}
